import "./ProductFilterOpenButton.scss";
import Button, { BUTTON_ICON_ALIGNMENTS } from "app/pages/.shared/form/Button";
import PropTypes from "prop-types";
import FilterIcon from "app/features/filters/productFilters/icons/FilterIcon";
import { FormattedMessage } from "react-intl";
import useOnSticky from "app/pages/.shared/useOnSticky";
import classNames from "classnames";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const ProductFilterOpenButton = ({ onClick, className, selectedFiltersCount = 0 }) => {
	const { ref, isSticky } = useOnSticky();

	const buttonWrapperClassName = classNames("product-filter-open-button-wrapper", {
		"product-filter-open-button-wrapper--sticky": isSticky,
		[className]: className?.length > 0,
	});

	const buttonClassName = classNames("product-filter-open-button", {
		"product-filter-open-button--active": selectedFiltersCount > 0,
	});

	return (
		<>
			<div ref={ref} />
			<section className={buttonWrapperClassName}>
				<Button
					onClick={onClick}
					className={buttonClassName}
					alignIcon={BUTTON_ICON_ALIGNMENTS.LEFT}
					icon={<FilterIcon />}
				>
					<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} isBold>
						<FormattedMessage id="filter.mobile.button.label" />

						{selectedFiltersCount > 0 && ` (${selectedFiltersCount})`}
					</Typography>
				</Button>
			</section>
		</>
	);
};

ProductFilterOpenButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	selectedFiltersCount: PropTypes.number,
};

export default ProductFilterOpenButton;
